const FileIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{flexShrink: 0}}
    >
      <path
        d="M2.625 8C2.625 5.17157 2.625 3.75736 3.5586 2.87868C4.49219 2 5.9948 2 9 2H9.57954C12.0254 2 13.2484 2 14.0977 2.59838C14.341 2.76982 14.5571 2.97314 14.7392 3.20217C15.375 4.0015 15.375 5.15252 15.375 7.45455V9.36364C15.375 11.586 15.375 12.6972 15.0233 13.5847C14.4579 15.0114 13.2621 16.1368 11.7462 16.669C10.8033 17 9.62264 17 7.26136 17C5.91206 17 5.23741 17 4.69858 16.8108C3.83234 16.5068 3.14906 15.8637 2.82597 15.0484C2.625 14.5413 2.625 13.9063 2.625 12.6364V8Z"
        stroke="white"
        stroke-width="1.1875"
        stroke-linejoin="round"
      />
      <path
        d="M15.375 9.5C15.375 10.8807 14.2557 12 12.875 12C12.3757 12 11.787 11.9125 11.3015 12.0426C10.8701 12.1582 10.5332 12.4951 10.4176 12.9265C10.2875 13.412 10.375 14.0007 10.375 14.5C10.375 15.8807 9.25571 17 7.875 17"
        stroke="white"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 5.75H11.25"
        stroke="white"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 8.75H8.25"
        stroke="white"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FileIcon
